export const MODEL_DIFF_DISPLAY_MODE = {
    DETAILED: 'DETAILED',
    COUNT_ONLY: 'COUNT_ONLY',
} as const;

export const REPORTS_DIFF_AVAILABILITY = {
    AVAILABLE: 'AVAILABLE',
    REPORTS_CHANGES_PREVIEW: 'REPORTS_CHANGES_PREVIEW',
    BLOCKED_BY_MODEL_DIFFS: 'BLOCKED_BY_MODEL_DIFFS',
    UNAVAILABLE: 'UNAVAILABLE',
} as const;

export const REPORT_FIELD_DIFF_PROPERTY = {
    CORE_VALUE: 'CORE_VALUE',
} as const;

export const MODEL_DIFF_PROPERTY = {
    CALCULATION: 'CALCULATION',
    TIMEFRAME: 'TIMEFRAME',
    VERTICAL_POSITION: 'VERTICAL_POSITION',
} as const;

export const REPORT_CELL_DIFF_KIND = {
    VALUE: 'VALUE',
    CALCULATED_VALUE: 'CALCULATED_VALUE',
    OTHER: 'OTHER',
} as const;

export const EMPTY_DIFF_VALUE_LABEL = '(empty)';
